import { SessionHelper } from "app/helpers/sessionHelper";
import ENV from "../../config";
import { api } from "../helpers/apiHelper";
import { api as api3 } from "../helpers/apiHelperV3";
import { urls } from "./urls";

const API_VALIDATE = "/bets/multipliers/validation";
const API_BET_BUILDER = urls.bets.API_BET_BUILDER();
const API_MARKET_CHECK = "/bets/multipliers/isMarketEnabled";
const API_BETS = "/bets";

/**
 * Validate multiples bets to check for errors
 */
export const validateMultiples = (payload: Object): any => {
  const url = API_VALIDATE;
  return api.post(url, payload);
};

/**
 * Validate bet builder bets to check for errors
 */
export const validateBetBuilder = (payload: Object): any => {
  const url = API_BET_BUILDER;
  return api3.post(url, payload);
};

/**
 * Check if market is enabled for multiples
 */
export const isMarketEnabled = (id: number): any => {
  const url = `${API_MARKET_CHECK}/${id}`;
  return api.get(url);
};

/**
 * Place multiples bet
 */
export const placeMultiple = (
  multiplierBetLegs: { odds: number; runnerId: number }[],
  stake: number,
  oddsType: string,
  request_id: string,
  oddsTotal: number,
  isBetBuilder: boolean = false
): any => {
  const url = API_BETS;
  const platform =
    ENV.CSS_THEME !== "GALAXYBET"
      ? SessionHelper.isAsianRouteAndSessionView()
        ? "asian"
        : "euro"
      : "ga3688";

  const data = {
    bets: [
      {
        multiplierBetLegs: multiplierBetLegs,
        stake,
        submittedType: "MULTIPLIER",
        odds: oddsTotal,
        oddsType: oddsType,
        betBuilder: isBetBuilder,
      },
    ],
    // oddsType: oddsType,
    platform: platform,
  };
  // Add UUID to the request header when placing a bet, to uniqely identify each POST to /bets endpoint
  const UUIDinterceptor = api.interceptors.request.use(request => {
    request.headers["request_id"] = request_id;
    return request;
  });

  return api
    .post(url, data)
    .then(resp => {
      api.interceptors.request.eject(UUIDinterceptor);
      return resp.data;
    })
    .catch(error => {
      console.log("placeBet error :", error);
      api.interceptors.request.eject(UUIDinterceptor);
      throw error;
    });
};
